import React from "react";
/* eslint-disable */
import {
  Box, TableHead, TableBody, TableCell, TableContainer, TableRow, Table
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {

  _originalDocumentTitle = null;

  componentDidMount() {

    this._beforePrint = () => {
      this._originalDocumentTitle = document.title;
      document.title = '';
    };
    this._afterPrint = () => {
      if (this._originalDocumentTitle !== null) {
        document.title = this._originalDocumentTitle;
        this._originalDocumentTitle = null;
      }
    };
    window.addEventListener('beforeprint', this._beforePrint);
    window.addEventListener('afterprint', this._afterPrint);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeprint', this._beforePrint);
    window.removeEventListener('afterprint', this._afterPrint);
  }

  getFirstAvailableValue(row, keys, defaultValue = '') {
    if (!row) {
      return defaultValue;
    }
    for (const key of keys) {
      const value = row[key];
      if (value !== undefined && value !== null && value !== '') {
        return value;
      }
    }
    return defaultValue;
  }

  formatAmount(value) {
    const numberValue = parseFloat(value);
    if (!Number.isFinite(numberValue)) {
      return '-';
    }
    return numberValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  formatDate(value) {
    if (!value) {
      return '';
    }
    return moment(value).format('YYYY/MM/DD');
  }

  toNumber(value, defaultValue = 0) {
    const numberValue = parseFloat(value);
    return Number.isFinite(numberValue) ? numberValue : defaultValue;
  }

  calculateStockSummary(data) {
    const rows = Array.isArray(data) ? data : [];
    if (rows.length === 0) {
      return null;
    }

    const openingQtyKeys = ['openingQtyInHand', 'openingQty', 'openingStockQty', 'openingStockQuantity', 'openingQuantity', 'openingStock'];
    const qtyInHandKeyCandidates = ['fDCInbound', 'fdcInbound', 'FDCInbound'];
    const unitCostKeys = ['wacPrice', 'wACPrice', 'wac', 'costPrice', 'unitPrice', 'avgCost', 'averageCost'];
    const valueKeys = ['value', 'totalValue', 'stockValue', 'inHandValue', 'qtyInHandValue', 'closingValue'];
    const openingValueKeys = ['openingValue', 'openingStockValue', 'openingStockAmount'];
    const totalQtyKeys = ['totalQty', 'TotalQty'];

    const qtyInHandKey = qtyInHandKeyCandidates.find((key) => rows.some((r) => r && r[key] !== undefined && r[key] !== null && r[key] !== ''));

    const skuName = this.getFirstAvailableValue(rows[0], ['skuName', 'sku', 'productName'], '');
    const skuCode = this.getFirstAvailableValue(rows[0], ['skuCode', 'sku_code'], '');

    let openingQty = 0;
    let qtyInHand = 0;
    let qtyInHandHasAny = false;
    let weightedCostNumerator = 0;
    let weightedCostDenominator = 0;
    let totalValue = 0;
    let totalValueHasAny = false;
    let openingValue = 0;
    let openingValueHasAny = false;
    let totalInvoiceAmount = 0;
    let totalQty = 0;

    rows.forEach((row) => {
      const openingQtyRow = this.toNumber(this.getFirstAvailableValue(row, openingQtyKeys, 0), 0);
      const qtyInHandRaw = qtyInHandKey ? row?.[qtyInHandKey] : null;
      const qtyInHandRow = this.toNumber(qtyInHandRaw, 0);
      const unitCostRow = this.toNumber(this.getFirstAvailableValue(row, unitCostKeys, null), NaN);
      const rawInvoiceAmount = this.toNumber(this.getFirstAvailableValue(row, ['invoiceAmount'], 0), 0);
      const invoiceAmountRow = rawInvoiceAmount === 0 ? this.toNumber(this.getFirstAvailableValue(row, ['specialInvoiceAmount'], 0), 0) : rawInvoiceAmount;
      const rawTotalQty = this.toNumber(this.getFirstAvailableValue(row, totalQtyKeys, 0), 0);
      const totalQtyRow = rawTotalQty === 0 ? this.toNumber(this.getFirstAvailableValue(row, ['specialTotalQty'], 0), 0) : rawTotalQty;

      openingQty += openingQtyRow;
      if (qtyInHandKey) {
        qtyInHand += qtyInHandRow;
        qtyInHandHasAny = true;
      }
      totalInvoiceAmount += invoiceAmountRow;
      totalQty += totalQtyRow;

      if (qtyInHandKey && Number.isFinite(unitCostRow)) {
        weightedCostNumerator += qtyInHandRow * unitCostRow;
        weightedCostDenominator += qtyInHandRow;
      }

      const rowValueRaw = this.getFirstAvailableValue(row, valueKeys, null);
      const rowValue = this.toNumber(rowValueRaw, NaN);
      if (Number.isFinite(rowValue)) {
        totalValue += rowValue;
        totalValueHasAny = true;
      } else if (qtyInHandKey && Number.isFinite(unitCostRow)) {
        totalValue += qtyInHandRow * unitCostRow;
        totalValueHasAny = true;
      }

      const openingValueRaw = this.getFirstAvailableValue(row, openingValueKeys, null);
      const openingValueRow = this.toNumber(openingValueRaw, NaN);
      if (Number.isFinite(openingValueRow)) {
        openingValue += openingValueRow;
        openingValueHasAny = true;
      } else if (Number.isFinite(unitCostRow)) {
        openingValue += openingQtyRow * unitCostRow;
        openingValueHasAny = true;
      }
    });

    let wacPrice = 0;
    if (qtyInHandHasAny && qtyInHand !== 0 && totalValueHasAny) {
      wacPrice = totalValue / qtyInHand;
    } else if (weightedCostDenominator !== 0) {
      wacPrice = weightedCostNumerator / weightedCostDenominator;
    }

    const openingValueComputed = openingValueHasAny ? openingValue : openingQty * wacPrice;

    const qtyInHandComputed = qtyInHandHasAny ? qtyInHand : NaN;

    const costPrice = qtyInHand !== 0 ? (totalInvoiceAmount / qtyInHand) : NaN;
    const qtyValueComputed = (qtyInHandHasAny && Number.isFinite(costPrice)) ? (qtyInHand * costPrice) : NaN;

    return {
      skuName,
      skuCode,
      openingQty,
      openingValue: openingValueComputed,
      qtyInHand: qtyInHandComputed,
      qtyValue: qtyValueComputed,
      wacPrice,
      costPrice
    };
  }

  clampNumber(value, min, max) {
    if (!Number.isFinite(value)) {
      return min;
    }
    return Math.min(max, Math.max(min, value));
  }

  buildReportTableLayout(reportData) {
    const rows = Array.isArray(reportData) ? reportData : [];
    const columns = [
      {
        key: 'date',
        header: 'Date',
        constraints: { min: 7, max: 10 },
        getValue: (row) => this.formatDate(this.getFirstAvailableValue(row, ['createdDate'], null))
      },
      {
        key: 'skuCode',
        header: 'SKU Code',
        constraints: { min: 7, max: 10 },
        getValue: (row) => this.getFirstAvailableValue(row, ['skuCode'], '')
      },
      {
        key: 'sku',
        header: 'SKU',
        constraints: { min: 9, max: 16 },
        getValue: (row) => this.getFirstAvailableValue(row, ['skuName'], '')
      },
      {
        key: 'fcc',
        header: 'FCC',
        constraints: { min: 8, max: 14 },
        getValue: (row) => this.getFirstAvailableValue(row, ['factoryName'], '')
      },
      {
        key: 'supplierCode',
        header: 'Supplier Code',
        constraints: { min: 8, max: 12 },
        getValue: (row) => this.getFirstAvailableValue(row, ['farmerCode'], '')
      },
      {
        key: 'supplierName',
        header: 'Supplier name',
        constraints: { min: 9, max: 16 },
        getValue: (row) => this.getFirstAvailableValue(row, ['givenName'], '')
      },
      {
        key: 'gtn',
        header: 'GTN Number',
        constraints: { min: 10, max: 18 },
        getValue: (row) => this.getFirstAvailableValue(row, ['gtnNumber'], '')
      },
      {
        key: 'invoice',
        header: 'Invoice Number',
        constraints: { min: 8, max: 14 },
        getValue: (row) => this.getFirstAvailableValue(row, ['invoiceNumber'], '')
      },
      {
        key: 'qty',
        header: 'FCC Outbound Quantity',
        constraints: { min: 8, max: 12 },
        getValue: (row) => this.formatAmount(this.getFirstAvailableValue(row, ['fccOutbound'], null))
      },
      {
        key: 'amount',
        header: 'Invoice Amount',
        constraints: { min: 8, max: 12 },
        getValue: (row) => this.formatAmount(this.getFirstAvailableValue(row, ['invoiceAmount'], null))
      }
    ];

    const maxLenByKey = {};
    let overallMaxLen = 0;
    columns.forEach((c) => {
      maxLenByKey[c.key] = (c.header || '').toString().length;
    });

    rows.forEach((row) => {
      columns.forEach((c) => {
        const value = c.getValue(row);
        const str = value === null || value === undefined ? '' : value.toString();
        const len = str.length;
        if (len > maxLenByKey[c.key]) {
          maxLenByKey[c.key] = len;
        }
      });
    });

    columns.forEach((c) => {
      overallMaxLen = Math.max(overallMaxLen, maxLenByKey[c.key] || 0);
    });

    const weights = columns.map((c) => Math.sqrt(Math.max(1, maxLenByKey[c.key] || 1)));
    const weightSum = weights.reduce((acc, w) => acc + w, 0) || 1;

    const initialPercents = columns.map((c, idx) => {
      const raw = (weights[idx] / weightSum) * 100;
      return this.clampNumber(raw, c.constraints.min, c.constraints.max);
    });

    const percents = [...initialPercents];
    const minByIdx = columns.map((c) => c.constraints.min);
    const maxByIdx = columns.map((c) => c.constraints.max);

    const total = () => percents.reduce((acc, p) => acc + p, 0);
    let delta = 100 - total();

    for (let guard = 0; guard < 200 && Math.abs(delta) > 0.01; guard += 1) {
      const adjustable = columns
        .map((_, idx) => idx)
        .filter((idx) => {
          if (delta > 0) return percents[idx] < maxByIdx[idx] - 0.0001;
          return percents[idx] > minByIdx[idx] + 0.0001;
        });

      if (adjustable.length === 0) {
        break;
      }

      const step = delta / adjustable.length;
      adjustable.forEach((idx) => {
        const next = percents[idx] + step;
        percents[idx] = this.clampNumber(next, minByIdx[idx], maxByIdx[idx]);
      });

      delta = 100 - total();
    }

    let fontSize = 9;
    if (overallMaxLen >= 35) {
      fontSize = 8;
    } else if (overallMaxLen <= 18) {
      fontSize = 10;
    }

    return {
      columns,
      columnPercents: percents,
      fontSize
    };
  }

  render() {
    const reportData = this.props.reportData;
    const data = this.props.searchData;
    const totalValues = this.props.totalRowValue;
    const emptyRows = 0;

    const layout = this.buildReportTableLayout(reportData);

    return (
      <div
        className="inventory-history-report-print"
        style={{ padding: '10px', '--inv-report-font-size': `${layout.fontSize}px` }}
      >
        <style>
          {`
            /* Keep all print styles inside the printable component so ReactToPrint picks them up. */
            @media print {
              @page {
                size: A4 landscape;
                /* Set margin to 0 to suppress browser-printed URL and date/time headers/footers */
                margin: 0;
              }

              html,
              body {
                margin: 0 !important;
                padding: 0 !important;
              }

              .inventory-history-report-print {
                /* Replace the suppressed @page margin with inner padding */
                padding: 12mm 12mm 12mm 12mm !important;
              }

              .inventory-history-report-table {
                width: 100% !important;
                table-layout: fixed !important;
                border-collapse: collapse;
              }

              .inventory-history-report-print .MuiTableContainer-root {
                overflow: visible !important;
              }

              .inventory-history-report-cell {
                font-size: var(--inv-report-font-size, 9px) !important;
                padding: 2px 4px !important;
                line-height: 1.2 !important;
                white-space: normal !important;
                overflow-wrap: anywhere !important;
                word-break: break-word !important;
              }
            }
          `}
        </style>
        <h3 style={{ marginTop: '16px', marginBottom: '4px' }}><center><u>Inventory History Report</u></center></h3>
        {(() => {
          const summary = this.calculateStockSummary(reportData);
          if (!summary) {
            return null;
          }
          return (
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '28px', marginBottom: '28px' }}>
              <TableContainer style={{ width: '460px', marginRight: '5px' }}>
                <Table size="small" aria-label="stock summary" style={{ borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                  <colgroup>
                    <col style={{ width: '38%' }} />
                    <col style={{ width: '22%' }} />
                    <col style={{ width: '14%' }} />
                    <col style={{ width: '26%' }} />
                  </colgroup>
                  <TableBody>
                    <TableRow>
                      <TableCell align="left">Opening QTY Hand</TableCell>
                      <TableCell align="left">{this.formatAmount(summary.openingQty)}</TableCell>
                      <TableCell align="left" style={{ paddingLeft: '40px' }}>Value</TableCell>
                      <TableCell align="right">{this.formatAmount(summary.openingValue)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">QTY In Hand</TableCell>
                      <TableCell align="left">{this.formatAmount(summary.qtyInHand)}</TableCell>
                      <TableCell align="left" style={{ paddingLeft: '40px' }}>Value</TableCell>
                      <TableCell align="right">{this.formatAmount(summary.qtyValue)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left">Cost Price</TableCell>
                      <TableCell align="left">{this.formatAmount(summary.costPrice)}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          );
        })()}
        <Box style={{ width: '100%' }}>
          <TableContainer>
            <Table className="inventory-history-report-table" aria-label="caption table" size="small">
              <colgroup>
                {layout.columns.map((col, idx) => (
                  <col key={col.key} style={{ width: `${layout.columnPercents[idx]}%` }} />
                ))}
              </colgroup>
              <TableHead>
                <TableRow>
                  <TableCell className="inventory-history-report-cell" sx={{ fontWeight: "bold", border: "1px solid black" }} align="left">Date</TableCell>
                  <TableCell className="inventory-history-report-cell" sx={{ fontWeight: "bold", border: "1px solid black" }} align="left">SKU Code</TableCell>
                  <TableCell className="inventory-history-report-cell" sx={{ fontWeight: "bold", border: "1px solid black" }} align="left">SKU</TableCell>
                  <TableCell className="inventory-history-report-cell" sx={{ fontWeight: "bold", border: "1px solid black" }} align="left">FCC</TableCell>
                  <TableCell className="inventory-history-report-cell" sx={{ fontWeight: "bold", border: "1px solid black" }} align="left">Supplier Code</TableCell>
                  <TableCell className="inventory-history-report-cell" sx={{ fontWeight: "bold", border: "1px solid black" }} align="left">Supplier name</TableCell>
                  <TableCell className="inventory-history-report-cell" sx={{ fontWeight: "bold", border: "1px solid black" }} align="left">GTN Number</TableCell>
                  <TableCell className="inventory-history-report-cell" sx={{ fontWeight: "bold", border: "1px solid black" }} align="left">Invoice Number</TableCell>
                  <TableCell className="inventory-history-report-cell" sx={{ fontWeight: "bold", border: "1px solid black" }} align="right">FCC Outbound Quantity</TableCell>
                  <TableCell className="inventory-history-report-cell" sx={{ fontWeight: "bold", border: "1px solid black" }} align="right">Invoice Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reportData.map((row, rowIndex) => {
                  const outboundQty = this.getFirstAvailableValue(row, ['fccOutbound'], null);
                  const rawInvoiceAmount = this.getFirstAvailableValue(row, ['invoiceAmount'], null);
                  const invoiceAmount = (rawInvoiceAmount === null || parseFloat(rawInvoiceAmount) === 0)
                    ? this.getFirstAvailableValue(row, ['specialInvoiceAmount'], rawInvoiceAmount)
                    : rawInvoiceAmount;

                  return (
                    <TableRow key={rowIndex}>
                      <TableCell className="inventory-history-report-cell" sx={{ border: "1px solid black" }} align="left">
                        {this.formatDate(this.getFirstAvailableValue(row, ['createdDate'], null))}
                      </TableCell>
                      <TableCell className="inventory-history-report-cell" sx={{ border: "1px solid black" }} align="left">{this.getFirstAvailableValue(row, ['skuCode'], '')}</TableCell>
                      <TableCell className="inventory-history-report-cell" sx={{ border: "1px solid black" }} align="left">{this.getFirstAvailableValue(row, ['skuName'], '')}</TableCell>
                      <TableCell className="inventory-history-report-cell" sx={{ border: "1px solid black" }} align="left">{this.getFirstAvailableValue(row, ['factoryName'], '')}</TableCell>
                      <TableCell className="inventory-history-report-cell" sx={{ border: "1px solid black" }} align="left">{this.getFirstAvailableValue(row, ['farmerCode'], '')}</TableCell>
                      <TableCell className="inventory-history-report-cell" sx={{ border: "1px solid black" }} align="right">{this.getFirstAvailableValue(row, ['givenName'], '')}</TableCell>
                      <TableCell className="inventory-history-report-cell" sx={{ border: "1px solid black" }} align="right">{this.getFirstAvailableValue(row, ['gtnNumber'], '')}</TableCell>
                      <TableCell className="inventory-history-report-cell" sx={{ border: "1px solid black" }} align="right">{this.getFirstAvailableValue(row, ['invoiceNumber'], '')}</TableCell>
                      <TableCell className="inventory-history-report-cell" sx={{ border: "1px solid black" }} align="right">{this.formatAmount(outboundQty)}</TableCell>
                      <TableCell className="inventory-history-report-cell" sx={{ border: "1px solid black" }} align="right">{this.formatAmount(invoiceAmount)}</TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={10} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    );
  }
}
